module.exports = __webpack_public_path__ + "img/doctor.04ff9d89.png";